import SimpleMeasurementModel from "../../models/standard/SimpleMeasurementModel";

// Helper function to serialize a single measurement.
export function serializeMeasurement(m: SimpleMeasurementModel) {
  return {
    id: m.id,
    startPoint: {
      x: m.startPoint.x,
      y: m.startPoint.y,
      z: m.startPoint.z,
    },
    endPoint: m.endPoint
      ? {
          x: m.endPoint.x,
          y: m.endPoint.y,
          z: m.endPoint.z,
        }
      : null,
    color: m.color,
    userId: m.userId,
    creationDate: m.creationDate.toISOString(),
    modificationDate: m.modificationDate.toISOString(),
  };
}